import { useTranslations } from 'next-intl'

import { PwaInstallationTrigger } from '@/components/pwa/pwa-installation-trigger'

import { PreferencesSectionHeader } from './preferences-section-header'

const PwaTab = () => {
  const t = useTranslations('UserPreferences')
  return (
    <div className="flex h-full flex-col">
      <PreferencesSectionHeader
        title={t('pwa.title')}
        description={t('pwa.description')}
        titleClassName="text-lg font-semibold tracking-tight"
      />
      <div className="p-6">
        <PwaInstallationTrigger />
      </div>
    </div>
  )
}
PwaTab.displayName = 'PwaTab'

export { PwaTab }
